import React, { useEffect, useState } from "react";

import commonFunction from "../../../../lib/utils/common";
import search_type_const from "../../../../lib/utils/hotel/constants.json";
import { invalidAlphanumeric } from "../../../../lib/utils/regex_cheat_sheet";
// import styles from "./index.module.css";

export default function HotelAutoComplete(props) {
  // console.log("props==>", props);
  const autoSuggestList = props.autoCompleteData;
  let recentSearchList =
    props.getrecentSearchList == null ? [] : props.getrecentSearchList;
  let mainArray = [];
  // console.log("recentSearchList==>", recentSearchList)
  if (
    recentSearchList &&
    recentSearchList?.length > 0 &&
    autoSuggestList?.length > 0
  ) {
    mainArray = autoSuggestList.concat(recentSearchList);
  } else if (recentSearchList?.length == 0 && autoSuggestList?.length > 0) {
    mainArray = autoSuggestList;
  } else if (recentSearchList?.length > 0 && autoSuggestList?.length == 0) {
    mainArray = recentSearchList;
  }

  if (mainArray.length > 0) {
    const ids = mainArray.map(({ destination_id }) => destination_id);
    mainArray = mainArray.filter(
      ({ destination_id }, index) => !ids.includes(destination_id, index + 1)
    );
  }

  return (
    <div className={props?.styles?.hotel_search_wid_inputfield}>
      <label className={props.isMobile ? props?.styles?.hiddenOnMobile : ""}>
        {props.label}
      </label>
      <div className={props?.styles?.hotel_search_wid_inputfield_main}>
        {/* <img src={props.leftIcon} className={props.styles?.hotel_search_left_icon} /> */}

        {/* <span
          className={props.styles?.hotel_search_left_icon}
          onClick={() => {
            props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
            props.onChangeHotelName("");
            props.onClickHotelInput();
          }}
        >
          {props.leftIcon}
        </span> */}
        <input
          type="text"
          autoComplete={"off"}
          id="hotels_location_input"
          tabIndex="1"
          readOnly
          // onFocus={props.onInputFocus}
          // onKeyDown={props.onKeyDownArrow}
          placeholder={
            !commonFunction.isValueEmpty(props.placholder)
              ? props.placholder
              : ""
          }
          className={`${props.styles?.search_widget_input_new} ${
            props.isMobile ? props?.styles?.hiddenOnMobile : ""
          }`}
          value={
            props?.isDetailPage
              ? props?.selectedHotel
              : !commonFunction.isValueEmpty(props.value) &&
                !props.expandAutoCompleteBool
              ? props.value
              : ""
          }
          // onChange={(event) => {
          //   props.onChangeHotelName(event.target.value);
          // }}
          onClick={() => {
            props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
            props.onChangeHotelName("");
            props.onClickHotelInput();
          }}
          disabled={props.disabled}
        />
        {props.isError && !commonFunction.isValueEmpty(props.isError) && (
          <div className={props.styles?.hotel_search_error_message}>
            <span>
              {props.value === "" 
                ? "Enter destination" 
                : props.autoCompleteData.length === 0 
                ? "Enter valid destination" 
                : ""}
            </span>
          </div>
        )}
        {/* {!commonFunction.isValueEmpty(props.isError) &&
        props.isError === true ? (
          <div className={props.styles?.hotel_search_error_message}>
            <span>{props.value != "" ? "" : "Enter destination"}</span>
          </div>
        ) : null}
        {!commonFunction.isValueEmpty(props.isError) &&
        props.isError === true ? (
          <div className={props.styles?.hotel_search_error_message}>
            <span>
              {props.autoCompleteData.length == 0
                ? "Enter valid destination"
                : ""}
            </span>
          </div>
        ) : null} */}
        {!props.isMobile && props.expandAutoCompleteBool === true ? (
          <div className={props.styles?.autocomp_container} tabIndex="1">
            <div
              className={`${props.styles?.autocomp_countryList} ${props.styles?.hotel_autocomplete_value}`}
              // id="hotelDataArray"
            >
              <div className={props.styles?.input_search_destination}>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14">
                  <defs>
                    <filter id="ve52ept4ca">
                      <feFlood
                        flood-color="#979797"
                        flood-opacity="1"
                        result="floodOut"
                      />
                      <feComposite
                        operator="atop"
                        in="floodOut"
                        in2="SourceGraphic"
                        result="compOut"
                      />
                      <feBlend in="compOut" in2="SourceGraphic" />
                    </filter>
                  </defs>
                  <g filter="url(#ve52ept4ca)">
                    <path
                      fill-rule="evenodd"
                      fill="#97144D"
                      d="M10.928 9.513A6.022 6.022 0 0 0 1.116 2.53C-.812 5.24-.179 8.1 2.531 10.928a6.021 6.021 0 0 0 6.982 0l2.83 2.83a1.004 1.004 0 0 0 1.415-1.415l-2.83-2.83zM2.006 6.031a4.016 4.016 0 0 1 8.029.006 4.015 4.015 0 0 1-8.029-.006z"
                    />
                  </g>
                </svg>
                <input
                  type="text"
                  autoComplete={"off"}
                  id="hotels_location_input"
                  // tabIndex="1"
                  onFocus={props.onInputFocus}
                  autoFocus
                  onKeyDown={props.onKeyDownArrow}
                  placeholder={
                    !commonFunction.isValueEmpty(props.placholder)
                      ? props.placholder
                      : ""
                  }
                  className={props.styles?.search_widget_input_new}
                  value={
                    !commonFunction.isValueEmpty(props.value) ? props.value : ""
                  }
                  onChange={(event) => {
                    props.onChangeHotelName(event.target.value);
                  }}
                  onClick={() => {
                    props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
                    props.onChangeHotelName("");
                    props.onClickHotelInput();
                  }}
                />
              </div>

              <div
                className={`${props.styles?.hotel_autocomplete_value} ${props.styles?.hotel_autocompleteMain}`}
                id="hotelDataArray"
              >
                {props.autoCompleteData.length == 0 && (
                  <>
                    <div className={props.styles.no_res}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="18"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M9.969 3.403V8.83c0 .124.05.242.138.33l3.863 3.836a.467.467 0 0 1-.33.796.475.475 0 0 1-.333-.137L9.445 9.818a1.393 1.393 0 0 1-.412-.988V3.403c0-.257.21-.465.468-.465.259 0 .468.208.468.465zm.747 14.33a8.652 8.652 0 0 1-4.864-.716.463.463 0 0 1-.2-.626.468.468 0 0 1 .63-.2 7.749 7.749 0 0 0 8.368-1.303 7.62 7.62 0 0 0 .525-10.816C12.314.941 7.439.707 4.287 3.55a7.622 7.622 0 0 0-.526 10.816v-1.009c0-.257.21-.465.469-.465.258 0 .468.208.468.465v2.092c0 .257-.21.466-.468.466H2.123a.467.467 0 0 1-.468-.466c0-.256.209-.465.468-.465h.953a8.579 8.579 0 0 1-2.15-4.567C.26 5.712 3.559 1.361 8.296.699c4.735-.66 9.112 2.616 9.779 7.319.665 4.701-2.628 9.048-7.359 9.715z"
                        />
                      </svg>
                      <p>No Result Found</p>
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="25"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M22.12 24.073H.518a.493.493 0 0 1-.495-.491V.98c0-.272.221-.491.495-.491h12.891c.274 0 .496.219.496.491v17.701c.546-.25 1.146-.387 1.77-.448V16.85h-.496a.493.493 0 0 1-.496-.49c0-.272.222-.492.496-.492h1.983c.274 0 .496.22.496.492 0 .271-.222.49-.496.49h-.496v1.374c2.604.238 4.668 2.283 4.908 4.866h.546c.274 0 .496.221.496.492 0 .27-.222.491-.496.491zM12.913 1.471H1.014V23.09H10.739c.009-.097.043-.187.057-.283a5.405 5.405 0 0 1 .267-1.064 5.62 5.62 0 0 1 .478-.983 5.53 5.53 0 0 1 .334-.469c.106-.135.21-.269.328-.394.137-.145.288-.274.441-.403.093-.08.17-.174.269-.247V1.471zm3.258 17.688c-.985 0-1.886.332-2.625.87a4.511 4.511 0 0 0-.558.479c-.073.075-.146.149-.214.229a4.432 4.432 0 0 0-.47.664c-.025.043-.057.08-.081.124a4.413 4.413 0 0 0-.346.89c-.025.089-.038.182-.057.273-.028.132-.035.268-.05.402h8.835c-.247-2.208-2.141-3.931-4.434-3.931zm-4.745-2.456H8.947a.494.494 0 0 1-.496-.491c0-.272.222-.492.496-.492h2.479c.274 0 .496.22.496.492a.494.494 0 0 1-.496.491zm0-3.931H8.947a.494.494 0 0 1-.496-.491c0-.271.222-.491.496-.491h2.479c.274 0 .496.22.496.491a.494.494 0 0 1-.496.491zm0-3.93H8.947a.494.494 0 0 1-.496-.492c0-.271.222-.491.496-.491h2.479c.274 0 .496.22.496.491a.494.494 0 0 1-.496.492zm0-3.932H8.947a.493.493 0 0 1-.496-.491c0-.272.222-.491.496-.491h2.479c.274 0 .496.219.496.491a.493.493 0 0 1-.496.491zM6.964 22.107a.494.494 0 0 1-.496-.491V2.945c0-.271.222-.491.496-.491s.495.22.495.491v18.671a.493.493 0 0 1-.495.491zm-1.983-1.473H2.502a.493.493 0 0 1-.496-.491c0-.272.221-.492.496-.492h2.479c.274 0 .495.22.495.492a.493.493 0 0 1-.495.491zm0-3.931H2.502a.493.493 0 0 1-.496-.491c0-.272.221-.492.496-.492h2.479c.274 0 .495.22.495.492a.493.493 0 0 1-.495.491zm0-3.931H2.502a.493.493 0 0 1-.496-.491c0-.271.221-.491.496-.491h2.479c.274 0 .495.22.495.491a.493.493 0 0 1-.495.491zm0-3.93H2.502a.494.494 0 0 1-.496-.492c0-.271.221-.491.496-.491h2.479c.274 0 .495.22.495.491a.494.494 0 0 1-.495.492zm0-3.932H2.502a.492.492 0 0 1-.496-.491c0-.272.221-.491.496-.491h2.479a.492.492 0 1 1 0 .982z"
                        />
                      </svg> */}
                    </div>
                  </>
                )}

                {!props.isKeyDown ||
                  (props.value == "" && (
                    <p className={props.styles?.suggestion_label}>
                      Suggestions
                    </p>
                  ))}

                {(props.isSearchDest || props.isKeyDown == false) &&
                  !commonFunction.isValueEmpty(props.autoCompleteData) &&
                  props.autoCompleteData.length > 0 &&
                  props.autoCompleteData.map((element) => {
                    console.log("element", element);
                    return (
                      <div
                        id="hotelData"
                        className={props.styles?.hotel_autocomplete_element}
                        onClick={() => {
                          props.onClickHotelName(element);
                          props.isAutoCompleteExpand(false);
                        }}
                        style={{ paddingTop: 10 }}
                      >
                        {/* <img
                        src={
                          element.property_count === 0
                            ? "/images/hotels-new.svg"
                            : "/images/location-icon.svg"
                        }
                      /> */}
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22">
                          <path fill-rule="evenodd" d="m14.769 13.53-6.191 8.098c-.06.06-.151.121-.241.121a.277.277 0 0 1-.242-.121l-6.19-8.098a8.117 8.117 0 0 1 0-9.821C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.172a8.12 8.12 0 0 1 0 9.821zm-.483-9.458a7.48 7.48 0 0 0-5.949-2.93c-2.356 0-4.53 1.057-5.949 2.93a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zm-5.949 9.397c-2.658 0-4.832-2.175-4.832-4.834S5.679 3.8 8.337 3.8c2.657 0 4.831 2.176 4.831 4.835s-2.174 4.834-4.831 4.834zm0-9.064a4.241 4.241 0 0 0-4.228 4.23 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.241 4.241 0 0 0-4.228-4.23z"/>
                      </svg> */}
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="18"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M9.969 3.402V8.83c0 .124.05.243.138.33l3.863 3.836a.465.465 0 0 1-.33.795.466.466 0 0 1-.333-.137L9.445 9.818a1.393 1.393 0 0 1-.412-.988V3.402c0-.256.21-.464.468-.464.259 0 .468.208.468.464zm.747 14.331a8.652 8.652 0 0 1-4.864-.716.463.463 0 0 1-.2-.626.468.468 0 0 1 .63-.2 7.749 7.749 0 0 0 8.368-1.303 7.62 7.62 0 0 0 .525-10.816C12.314.941 7.439.708 4.287 3.55a7.622 7.622 0 0 0-.526 10.816v-1.009c0-.257.21-.465.469-.465.258 0 .468.208.468.465v2.092c0 .258-.21.466-.468.466H2.123a.466.466 0 1 1 0-.931h.953a8.582 8.582 0 0 1-2.15-4.567C.26 5.712 3.559 1.361 8.296.699c4.735-.66 9.112 2.616 9.779 7.319.665 4.701-2.628 9.048-7.359 9.715z"
                          />
                        </svg> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="22"
                        >
                          <path
                            fill-rule="evenodd"
                            d="m14.769 13.53-6.19 8.098c-.061.06-.152.12-.242.12a.276.276 0 0 1-.242-.12l-6.19-8.098a8.116 8.116 0 0 1 0-9.82C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.173a8.119 8.119 0 0 1 0 9.82zm-.483-9.458a7.482 7.482 0 0 0-5.949-2.931c-2.355 0-4.53 1.058-5.949 2.931a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zM8.337 13.47c-2.657 0-4.832-2.176-4.832-4.835S5.68 3.8 8.337 3.8s4.831 2.176 4.831 4.835-2.174 4.835-4.831 4.835zm0-9.066a4.242 4.242 0 0 0-4.228 4.231 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.242 4.242 0 0 0-4.228-4.231z"
                          />
                        </svg>
                        <div className={props.styles?.hotel_autocomplete_name}>
                          <div>{element.search_text}</div>
                          <div className={props.styles.hotel_list_flex}>
                            <div className={props.styles?.hotel_prop_city}>
                              {" "}
                              {""}
                            </div>
                            {element.property_count === 0 ? (
                              ""
                            ) : (
                              <div
                                className={props.styles?.hotel_autocomplete_tag}
                              >
                                {element.property_count} Properties
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={props.styles?.hotelnw_city}>
                          {element?.dest_type ? element?.dest_type?.text : " "}
                        </div>
                      </div>
                    );
                  })}

                {props.isKeyDown &&
                  !commonFunction.isValueEmpty(mainArray) &&
                  mainArray.length > 0 &&
                  mainArray.map((element) => {
                    console.log("element", element);
                    return (
                      <div
                        id="hotelData"
                        className={props.styles?.hotel_autocomplete_element}
                        onClick={() => {
                          props.onClickHotelName(element);
                          props.isAutoCompleteExpand(false);
                        }}
                        style={{ paddingTop: 10 }}
                      >
                        {/* <img
                        src={
                          element.property_count === 0
                            ? "/images/hotels-new.svg"
                            : "/images/location-icon.svg"
                        }
                      /> */}
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22">
                          <path fill-rule="evenodd" d="m14.769 13.53-6.191 8.098c-.06.06-.151.121-.241.121a.277.277 0 0 1-.242-.121l-6.19-8.098a8.117 8.117 0 0 1 0-9.821C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.172a8.12 8.12 0 0 1 0 9.821zm-.483-9.458a7.48 7.48 0 0 0-5.949-2.93c-2.356 0-4.53 1.057-5.949 2.93a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zm-5.949 9.397c-2.658 0-4.832-2.175-4.832-4.834S5.679 3.8 8.337 3.8c2.657 0 4.831 2.176 4.831 4.835s-2.174 4.834-4.831 4.834zm0-9.064a4.241 4.241 0 0 0-4.228 4.23 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.241 4.241 0 0 0-4.228-4.23z"/>
                      </svg> */}
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="18"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M9.969 3.402V8.83c0 .124.05.243.138.33l3.863 3.836a.465.465 0 0 1-.33.795.466.466 0 0 1-.333-.137L9.445 9.818a1.393 1.393 0 0 1-.412-.988V3.402c0-.256.21-.464.468-.464.259 0 .468.208.468.464zm.747 14.331a8.652 8.652 0 0 1-4.864-.716.463.463 0 0 1-.2-.626.468.468 0 0 1 .63-.2 7.749 7.749 0 0 0 8.368-1.303 7.62 7.62 0 0 0 .525-10.816C12.314.941 7.439.708 4.287 3.55a7.622 7.622 0 0 0-.526 10.816v-1.009c0-.257.21-.465.469-.465.258 0 .468.208.468.465v2.092c0 .258-.21.466-.468.466H2.123a.466.466 0 1 1 0-.931h.953a8.582 8.582 0 0 1-2.15-4.567C.26 5.712 3.559 1.361 8.296.699c4.735-.66 9.112 2.616 9.779 7.319.665 4.701-2.628 9.048-7.359 9.715z"
                          />
                        </svg> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="22"
                        >
                          <path
                            fill-rule="evenodd"
                            d="m14.769 13.53-6.19 8.098c-.061.06-.152.12-.242.12a.276.276 0 0 1-.242-.12l-6.19-8.098a8.116 8.116 0 0 1 0-9.82C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.173a8.119 8.119 0 0 1 0 9.82zm-.483-9.458a7.482 7.482 0 0 0-5.949-2.931c-2.355 0-4.53 1.058-5.949 2.931a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zM8.337 13.47c-2.657 0-4.832-2.176-4.832-4.835S5.68 3.8 8.337 3.8s4.831 2.176 4.831 4.835-2.174 4.835-4.831 4.835zm0-9.066a4.242 4.242 0 0 0-4.228 4.231 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.242 4.242 0 0 0-4.228-4.231z"
                          />
                        </svg>
                        <div className={props.styles?.hotel_autocomplete_name}>
                          <div>{element.search_text}</div>
                          <div className={props.styles.hotel_list_flex}>
                            <div className={props.styles?.hotel_prop_city}>
                              {" "}
                              {""}
                            </div>
                            {element.property_count === 0 ? (
                              ""
                            ) : (
                              <div
                                className={props.styles?.hotel_autocomplete_tag}
                              >
                                {element.property_count} Properties
                              </div>
                            )}
                          </div>
                        </div>
                        <div className={props.styles?.hotelnw_city}>
                          {element?.dest_type ? element?.dest_type?.text : " "}
                        </div>
                      </div>
                    );
                  })}

                {/* when user Logged in  */}
                {props.isKeyDown == false &&
                  props?.userProfile &&
                  props?.userProfile?.status && (
                    <>
                      <div className={props.styles.recent_container}>
                        {!commonFunction.isValueEmpty(
                          props.getrecentSearchList
                        ) &&
                          props.getrecentSearchList.length > 0 && (
                            <div className={props.styles.recent_label}>
                              Recent Search
                            </div>
                          )}

                        {!commonFunction.isValueEmpty(
                          props.getrecentSearchList
                        ) &&
                          props.getrecentSearchList.length > 0 &&
                          props.getrecentSearchList.map((recelement) => {
                            console.log("recelement", recelement);
                            return (
                              <div
                                className={
                                  props.styles.hotel_autocomplete_element
                                }
                              >
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22"><path fill-rule="evenodd" d="m14.769 13.53-6.191 8.098c-.06.06-.151.121-.241.121a.277.277 0 0 1-.242-.121l-6.19-8.098a8.117 8.117 0 0 1 0-9.821C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.172a8.12 8.12 0 0 1 0 9.821zm-.483-9.458a7.48 7.48 0 0 0-5.949-2.93c-2.356 0-4.53 1.057-5.949 2.93a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zm-5.949 9.397c-2.658 0-4.832-2.175-4.832-4.834S5.679 3.8 8.337 3.8c2.657 0 4.831 2.176 4.831 4.835s-2.174 4.834-4.831 4.834zm0-9.064a4.241 4.241 0 0 0-4.228 4.23 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.241 4.241 0 0 0-4.228-4.23z"></path></svg> */}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19"
                                  height="18"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M9.969 3.402V8.83c0 .124.05.243.138.33l3.863 3.836a.465.465 0 0 1-.33.795.466.466 0 0 1-.333-.137L9.445 9.818a1.393 1.393 0 0 1-.412-.988V3.402c0-.256.21-.464.468-.464.259 0 .468.208.468.464zm.747 14.331a8.652 8.652 0 0 1-4.864-.716.463.463 0 0 1-.2-.626.468.468 0 0 1 .63-.2 7.749 7.749 0 0 0 8.368-1.303 7.62 7.62 0 0 0 .525-10.816C12.314.941 7.439.708 4.287 3.55a7.622 7.622 0 0 0-.526 10.816v-1.009c0-.257.21-.465.469-.465.258 0 .468.208.468.465v2.092c0 .258-.21.466-.468.466H2.123a.466.466 0 1 1 0-.931h.953a8.582 8.582 0 0 1-2.15-4.567C.26 5.712 3.559 1.361 8.296.699c4.735-.66 9.112 2.616 9.779 7.319.665 4.701-2.628 9.048-7.359 9.715z"
                                  />
                                </svg>
                                <div
                                  className={
                                    props.styles.hotel_autocomplete_name
                                  }
                                  onClick={() => {
                                    props.onClickHotelName(recelement);
                                    props.isAutoCompleteExpand(false);
                                  }}
                                >
                                  <div
                                    className={
                                      props.styles.hotel_autocomplete_city
                                    }
                                  >
                                    {recelement.search_text}
                                  </div>

                                  <div
                                    className={
                                      props.styles.hotel_autocomplete_tag
                                    }
                                  >
                                    {" "}
                                    {recelement.property_count} Properties
                                  </div>
                                </div>
                                <div className={props.styles?.hotelnw_city}>
                                  {recelement?.dest_type
                                    ? recelement?.dest_type?.text
                                    : " "}
                                </div>
                                {/* <div className={props.styles.hotelnw_city}>province state</div> */}
                              </div>
                            );
                          })}
                      </div>
                    </>
                  )}

                {/* when user not Logged in  */}
                {props.isKeyDown == false &&
                  props?.userProfile &&
                  props?.userProfile?.status == false && (
                    <>
                      <div className={props.styles.recent_container}>
                        {!commonFunction.isValueEmpty(
                          props.getrecentSearchList
                        ) &&
                          props.getrecentSearchList.length > 0 && (
                            <div className={props.styles.recent_label}>
                              Recent Search
                            </div>
                          )}

                        {!commonFunction.isValueEmpty(
                          props.getrecentSearchList
                        ) &&
                          props.getrecentSearchList.length > 0 &&
                          props.getrecentSearchList.map((recelement) => {
                            console.log("recelement", recelement);
                            return (
                              <div
                                className={
                                  props.styles.hotel_autocomplete_element
                                }
                              >
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22"><path fill-rule="evenodd" d="m14.769 13.53-6.191 8.098c-.06.06-.151.121-.241.121a.277.277 0 0 1-.242-.121l-6.19-8.098a8.117 8.117 0 0 1 0-9.821C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.172a8.12 8.12 0 0 1 0 9.821zm-.483-9.458a7.48 7.48 0 0 0-5.949-2.93c-2.356 0-4.53 1.057-5.949 2.93a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zm-5.949 9.397c-2.658 0-4.832-2.175-4.832-4.834S5.679 3.8 8.337 3.8c2.657 0 4.831 2.176 4.831 4.835s-2.174 4.834-4.831 4.834zm0-9.064a4.241 4.241 0 0 0-4.228 4.23 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.241 4.241 0 0 0-4.228-4.23z"></path></svg> */}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19"
                                  height="18"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M9.969 3.402V8.83c0 .124.05.243.138.33l3.863 3.836a.465.465 0 0 1-.33.795.466.466 0 0 1-.333-.137L9.445 9.818a1.393 1.393 0 0 1-.412-.988V3.402c0-.256.21-.464.468-.464.259 0 .468.208.468.464zm.747 14.331a8.652 8.652 0 0 1-4.864-.716.463.463 0 0 1-.2-.626.468.468 0 0 1 .63-.2 7.749 7.749 0 0 0 8.368-1.303 7.62 7.62 0 0 0 .525-10.816C12.314.941 7.439.708 4.287 3.55a7.622 7.622 0 0 0-.526 10.816v-1.009c0-.257.21-.465.469-.465.258 0 .468.208.468.465v2.092c0 .258-.21.466-.468.466H2.123a.466.466 0 1 1 0-.931h.953a8.582 8.582 0 0 1-2.15-4.567C.26 5.712 3.559 1.361 8.296.699c4.735-.66 9.112 2.616 9.779 7.319.665 4.701-2.628 9.048-7.359 9.715z"
                                  />
                                </svg>
                                <div
                                  className={
                                    props.styles.hotel_autocomplete_name
                                  }
                                  onClick={() => {
                                    props.onClickHotelName(recelement);
                                    props.isAutoCompleteExpand(false);
                                  }}
                                >
                                  <div
                                    className={
                                      props.styles.hotel_autocomplete_city
                                    }
                                  >
                                    {recelement.search_text}
                                  </div>

                                  <div
                                    className={
                                      props.styles.hotel_autocomplete_tag
                                    }
                                  >
                                    {" "}
                                    {recelement.property_count} Properties
                                  </div>
                                </div>
                                <div className={props.styles?.hotelnw_city}>
                                  {recelement?.dest_type
                                    ? recelement?.dest_type?.text
                                    : " "}
                                </div>
                                {/* <div className={props.styles.hotelnw_city}>province state</div> */}
                              </div>
                            );
                          })}
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        ) : null}

        {props.isMobile && (
          <div className={props.styles?.autocomp_container} tabIndex="1">
            <div
              className={`${props.styles?.autocomp_countryList} ${props.styles?.hotel_autocomplete_value}`}
              id="hotelDataArray"
            >
              <div className={props.styles?.input_search_destination}>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14">
                  <defs>
                    <filter id="ve52ept4ca">
                      <feFlood
                        flood-color="#979797"
                        flood-opacity="1"
                        result="floodOut"
                      />
                      <feComposite
                        operator="atop"
                        in="floodOut"
                        in2="SourceGraphic"
                        result="compOut"
                      />
                      <feBlend in="compOut" in2="SourceGraphic" />
                    </filter>
                  </defs>
                  <g filter="url(#ve52ept4ca)">
                    <path
                      fill-rule="evenodd"
                      fill="#97144D"
                      d="M10.928 9.513A6.022 6.022 0 0 0 1.116 2.53C-.812 5.24-.179 8.1 2.531 10.928a6.021 6.021 0 0 0 6.982 0l2.83 2.83a1.004 1.004 0 0 0 1.415-1.415l-2.83-2.83zM2.006 6.031a4.016 4.016 0 0 1 8.029.006 4.015 4.015 0 0 1-8.029-.006z"
                    />
                  </g>
                </svg>
                <input
                  type="text"
                  autoComplete={"off"}
                  id="hotels_location_input"
                  tabIndex="1"
                  onFocus={props.onInputFocus}
                  autoFocus
                  onKeyDown={props.onKeyDownArrow}
                  placeholder={
                    !commonFunction.isValueEmpty(props.placholder)
                      ? props.placholder
                      : ""
                  }
                  className={props.styles?.search_widget_input_new}
                  value={
                    !commonFunction.isValueEmpty(props.value) ? props.value : ""
                  }
                  onChange={(event) => {
                    const newValue = event.target.value.replace(
                      invalidAlphanumeric,
                      ""
                    );
                    props.onChangeHotelName(newValue);
                  }}
                  onClick={() => {
                    props.isAutoCompleteExpand(!props.expandAutoCompleteBool);
                    props.onChangeHotelName("");
                    props.onClickHotelInput();
                  }}
                />
              </div>

              <div
                className={`${props.styles?.hotel_autocomplete_value} ${props.styles?.hotel_autocompleteMain}`}
              >
                {props.isMobile && (
                  <p className={props.styles?.suggestion_label}>Suggestions</p>
                )}

                {!commonFunction.isValueEmpty(props.autoCompleteData) &&
                  props.autoCompleteData.length > 0 &&
                  props.autoCompleteData.map((element) => {
                    let searchValue = props.value;
                    // console.log("element", element);
                    // console.log("searchValue======>",searchValue);

                    return (
                      <>
                        <div
                          id="hotelData"
                          className={props.styles?.hotel_autocomplete_element}
                          onClick={() => {
                            props.onClickHotelName(element);
                            props.isAutoCompleteExpand(false);
                          }}
                        >
                          {/* <img
                        src={
                          element.property_count === 0
                            ? "/images/hotels-new.svg"
                            : "/images/location-icon.svg"
                        }
                      /> */}
                          {/* <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22">
                          <path fill-rule="evenodd" d="m14.769 13.53-6.191 8.098c-.06.06-.151.121-.241.121a.277.277 0 0 1-.242-.121l-6.19-8.098a8.117 8.117 0 0 1 0-9.821C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.172a8.12 8.12 0 0 1 0 9.821zm-.483-9.458a7.48 7.48 0 0 0-5.949-2.93c-2.356 0-4.53 1.057-5.949 2.93a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zm-5.949 9.397c-2.658 0-4.832-2.175-4.832-4.834S5.679 3.8 8.337 3.8c2.657 0 4.831 2.176 4.831 4.835s-2.174 4.834-4.831 4.834zm0-9.064a4.241 4.241 0 0 0-4.228 4.23 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.241 4.241 0 0 0-4.228-4.23z"/>
                      </svg> */}
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="18"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M9.969 3.402V8.83c0 .124.05.243.138.33l3.863 3.836a.465.465 0 0 1-.33.795.466.466 0 0 1-.333-.137L9.445 9.818a1.393 1.393 0 0 1-.412-.988V3.402c0-.256.21-.464.468-.464.259 0 .468.208.468.464zm.747 14.331a8.652 8.652 0 0 1-4.864-.716.463.463 0 0 1-.2-.626.468.468 0 0 1 .63-.2 7.749 7.749 0 0 0 8.368-1.303 7.62 7.62 0 0 0 .525-10.816C12.314.941 7.439.708 4.287 3.55a7.622 7.622 0 0 0-.526 10.816v-1.009c0-.257.21-.465.469-.465.258 0 .468.208.468.465v2.092c0 .258-.21.466-.468.466H2.123a.466.466 0 1 1 0-.931h.953a8.582 8.582 0 0 1-2.15-4.567C.26 5.712 3.559 1.361 8.296.699c4.735-.66 9.112 2.616 9.779 7.319.665 4.701-2.628 9.048-7.359 9.715z"
                            />
                          </svg> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="22"
                          >
                            <path
                              fill-rule="evenodd"
                              d="m14.769 13.53-6.19 8.098c-.061.06-.152.12-.242.12a.276.276 0 0 1-.242-.12l-6.19-8.098a8.116 8.116 0 0 1 0-9.82C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.173a8.119 8.119 0 0 1 0 9.82zm-.483-9.458a7.482 7.482 0 0 0-5.949-2.931c-2.355 0-4.53 1.058-5.949 2.931a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zM8.337 13.47c-2.657 0-4.832-2.176-4.832-4.835S5.68 3.8 8.337 3.8s4.831 2.176 4.831 4.835-2.174 4.835-4.831 4.835zm0-9.066a4.242 4.242 0 0 0-4.228 4.231 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.242 4.242 0 0 0-4.228-4.231z"
                            />
                          </svg>
                          <div
                            className={props.styles?.hotel_autocomplete_name}
                          >
                            <div className={props.styles?.hotel_searchlabel}>
                              {element.search_text}
                              {/* {(searchValue != "" && element.search_text.includes(searchValue)) ?
                             <> <strong> {element.search_text}</strong>
                             </>:<>{element.search_text}</>}             */}
                            </div>
                            <div className={props.styles.hotel_list_flex}>
                              <div className={props.styles?.hotel_prop_city}>
                                {" "}
                                {""}
                              </div>
                              {element.property_count === 0 ? (
                                ""
                              ) : (
                                <div
                                  className={
                                    props.styles?.hotel_autocomplete_tag
                                  }
                                >
                                  {element.property_count} Properties
                                </div>
                              )}
                            </div>
                          </div>
                          <div className={props.styles?.hotelnw_city}>
                            {element?.search_type
                              ? search_type_const.search_type_const[
                                  element?.search_type
                                ]?.text
                              : " "}
                          </div>
                        </div>
                      </>
                    );
                  })}

                {props.autoCompleteData.length == 0 && (
                  <>
                    <div className={props.styles.no_res}>
                      {/* <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18">
                      <path fill-rule="evenodd" d="M9.969 3.403V8.83c0 .124.05.242.138.33l3.863 3.836a.467.467 0 0 1-.33.796.475.475 0 0 1-.333-.137L9.445 9.818a1.393 1.393 0 0 1-.412-.988V3.403c0-.257.21-.465.468-.465.259 0 .468.208.468.465zm.747 14.33a8.652 8.652 0 0 1-4.864-.716.463.463 0 0 1-.2-.626.468.468 0 0 1 .63-.2 7.749 7.749 0 0 0 8.368-1.303 7.62 7.62 0 0 0 .525-10.816C12.314.941 7.439.707 4.287 3.55a7.622 7.622 0 0 0-.526 10.816v-1.009c0-.257.21-.465.469-.465.258 0 .468.208.468.465v2.092c0 .257-.21.466-.468.466H2.123a.467.467 0 0 1-.468-.466c0-.256.209-.465.468-.465h.953a8.579 8.579 0 0 1-2.15-4.567C.26 5.712 3.559 1.361 8.296.699c4.735-.66 9.112 2.616 9.779 7.319.665 4.701-2.628 9.048-7.359 9.715z"/>
                  </svg> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="25"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M22.12 24.073H.518a.493.493 0 0 1-.495-.491V.98c0-.272.221-.491.495-.491h12.891c.274 0 .496.219.496.491v17.701c.546-.25 1.146-.387 1.77-.448V16.85h-.496a.493.493 0 0 1-.496-.49c0-.272.222-.492.496-.492h1.983c.274 0 .496.22.496.492 0 .271-.222.49-.496.49h-.496v1.374c2.604.238 4.668 2.283 4.908 4.866h.546c.274 0 .496.221.496.492 0 .27-.222.491-.496.491zM12.913 1.471H1.014V23.09H10.739c.009-.097.043-.187.057-.283a5.405 5.405 0 0 1 .267-1.064 5.62 5.62 0 0 1 .478-.983 5.53 5.53 0 0 1 .334-.469c.106-.135.21-.269.328-.394.137-.145.288-.274.441-.403.093-.08.17-.174.269-.247V1.471zm3.258 17.688c-.985 0-1.886.332-2.625.87a4.511 4.511 0 0 0-.558.479c-.073.075-.146.149-.214.229a4.432 4.432 0 0 0-.47.664c-.025.043-.057.08-.081.124a4.413 4.413 0 0 0-.346.89c-.025.089-.038.182-.057.273-.028.132-.035.268-.05.402h8.835c-.247-2.208-2.141-3.931-4.434-3.931zm-4.745-2.456H8.947a.494.494 0 0 1-.496-.491c0-.272.222-.492.496-.492h2.479c.274 0 .496.22.496.492a.494.494 0 0 1-.496.491zm0-3.931H8.947a.494.494 0 0 1-.496-.491c0-.271.222-.491.496-.491h2.479c.274 0 .496.22.496.491a.494.494 0 0 1-.496.491zm0-3.93H8.947a.494.494 0 0 1-.496-.492c0-.271.222-.491.496-.491h2.479c.274 0 .496.22.496.491a.494.494 0 0 1-.496.492zm0-3.932H8.947a.493.493 0 0 1-.496-.491c0-.272.222-.491.496-.491h2.479c.274 0 .496.219.496.491a.493.493 0 0 1-.496.491zM6.964 22.107a.494.494 0 0 1-.496-.491V2.945c0-.271.222-.491.496-.491s.495.22.495.491v18.671a.493.493 0 0 1-.495.491zm-1.983-1.473H2.502a.493.493 0 0 1-.496-.491c0-.272.221-.492.496-.492h2.479c.274 0 .495.22.495.492a.493.493 0 0 1-.495.491zm0-3.931H2.502a.493.493 0 0 1-.496-.491c0-.272.221-.492.496-.492h2.479c.274 0 .495.22.495.492a.493.493 0 0 1-.495.491zm0-3.931H2.502a.493.493 0 0 1-.496-.491c0-.271.221-.491.496-.491h2.479c.274 0 .495.22.495.491a.493.493 0 0 1-.495.491zm0-3.93H2.502a.494.494 0 0 1-.496-.492c0-.271.221-.491.496-.491h2.479c.274 0 .495.22.495.491a.494.494 0 0 1-.495.492zm0-3.932H2.502a.492.492 0 0 1-.496-.491c0-.272.221-.491.496-.491h2.479a.492.492 0 1 1 0 .982z"
                        />
                      </svg>
                      <p>No Result Found</p>
                      {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="25"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M22.12 24.073H.518a.493.493 0 0 1-.495-.491V.98c0-.272.221-.491.495-.491h12.891c.274 0 .496.219.496.491v17.701c.546-.25 1.146-.387 1.77-.448V16.85h-.496a.493.493 0 0 1-.496-.49c0-.272.222-.492.496-.492h1.983c.274 0 .496.22.496.492 0 .271-.222.49-.496.49h-.496v1.374c2.604.238 4.668 2.283 4.908 4.866h.546c.274 0 .496.221.496.492 0 .27-.222.491-.496.491zM12.913 1.471H1.014V23.09H10.739c.009-.097.043-.187.057-.283a5.405 5.405 0 0 1 .267-1.064 5.62 5.62 0 0 1 .478-.983 5.53 5.53 0 0 1 .334-.469c.106-.135.21-.269.328-.394.137-.145.288-.274.441-.403.093-.08.17-.174.269-.247V1.471zm3.258 17.688c-.985 0-1.886.332-2.625.87a4.511 4.511 0 0 0-.558.479c-.073.075-.146.149-.214.229a4.432 4.432 0 0 0-.47.664c-.025.043-.057.08-.081.124a4.413 4.413 0 0 0-.346.89c-.025.089-.038.182-.057.273-.028.132-.035.268-.05.402h8.835c-.247-2.208-2.141-3.931-4.434-3.931zm-4.745-2.456H8.947a.494.494 0 0 1-.496-.491c0-.272.222-.492.496-.492h2.479c.274 0 .496.22.496.492a.494.494 0 0 1-.496.491zm0-3.931H8.947a.494.494 0 0 1-.496-.491c0-.271.222-.491.496-.491h2.479c.274 0 .496.22.496.491a.494.494 0 0 1-.496.491zm0-3.93H8.947a.494.494 0 0 1-.496-.492c0-.271.222-.491.496-.491h2.479c.274 0 .496.22.496.491a.494.494 0 0 1-.496.492zm0-3.932H8.947a.493.493 0 0 1-.496-.491c0-.272.222-.491.496-.491h2.479c.274 0 .496.219.496.491a.493.493 0 0 1-.496.491zM6.964 22.107a.494.494 0 0 1-.496-.491V2.945c0-.271.222-.491.496-.491s.495.22.495.491v18.671a.493.493 0 0 1-.495.491zm-1.983-1.473H2.502a.493.493 0 0 1-.496-.491c0-.272.221-.492.496-.492h2.479c.274 0 .495.22.495.492a.493.493 0 0 1-.495.491zm0-3.931H2.502a.493.493 0 0 1-.496-.491c0-.272.221-.492.496-.492h2.479c.274 0 .495.22.495.492a.493.493 0 0 1-.495.491zm0-3.931H2.502a.493.493 0 0 1-.496-.491c0-.271.221-.491.496-.491h2.479c.274 0 .495.22.495.491a.493.493 0 0 1-.495.491zm0-3.93H2.502a.494.494 0 0 1-.496-.492c0-.271.221-.491.496-.491h2.479c.274 0 .495.22.495.491a.494.494 0 0 1-.495.492zm0-3.932H2.502a.492.492 0 0 1-.496-.491c0-.272.221-.491.496-.491h2.479a.492.492 0 1 1 0 .982z"
                        />
                      </svg> */}
                    </div>
                  </>
                )}

                {/* when user Logged in  */}
                {props?.userProfile && props?.userProfile?.status && (
                  <>
                    <div className={props.styles.recent_container}>
                      {!commonFunction.isValueEmpty(
                        props.getrecentSearchList
                      ) &&
                        props.getrecentSearchList.length > 0 && (
                          <div className={props.styles.recent_label}>
                            Recent Search
                          </div>
                        )}

                      {!commonFunction.isValueEmpty(
                        props.getrecentSearchList
                      ) &&
                        props.getrecentSearchList.length > 0 &&
                        props.getrecentSearchList.map((recelement) => {
                          console.log("recelement", recelement);
                          return (
                            <div
                              className={
                                props.styles.hotel_autocomplete_element
                              }
                            >
                              {/* <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22"><path fill-rule="evenodd" d="m14.769 13.53-6.191 8.098c-.06.06-.151.121-.241.121a.277.277 0 0 1-.242-.121l-6.19-8.098a8.117 8.117 0 0 1 0-9.821C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.172a8.12 8.12 0 0 1 0 9.821zm-.483-9.458a7.48 7.48 0 0 0-5.949-2.93c-2.356 0-4.53 1.057-5.949 2.93a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zm-5.949 9.397c-2.658 0-4.832-2.175-4.832-4.834S5.679 3.8 8.337 3.8c2.657 0 4.831 2.176 4.831 4.835s-2.174 4.834-4.831 4.834zm0-9.064a4.241 4.241 0 0 0-4.228 4.23 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.241 4.241 0 0 0-4.228-4.23z"></path></svg> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M9.969 3.402V8.83c0 .124.05.243.138.33l3.863 3.836a.465.465 0 0 1-.33.795.466.466 0 0 1-.333-.137L9.445 9.818a1.393 1.393 0 0 1-.412-.988V3.402c0-.256.21-.464.468-.464.259 0 .468.208.468.464zm.747 14.331a8.652 8.652 0 0 1-4.864-.716.463.463 0 0 1-.2-.626.468.468 0 0 1 .63-.2 7.749 7.749 0 0 0 8.368-1.303 7.62 7.62 0 0 0 .525-10.816C12.314.941 7.439.708 4.287 3.55a7.622 7.622 0 0 0-.526 10.816v-1.009c0-.257.21-.465.469-.465.258 0 .468.208.468.465v2.092c0 .258-.21.466-.468.466H2.123a.466.466 0 1 1 0-.931h.953a8.582 8.582 0 0 1-2.15-4.567C.26 5.712 3.559 1.361 8.296.699c4.735-.66 9.112 2.616 9.779 7.319.665 4.701-2.628 9.048-7.359 9.715z"
                                />
                              </svg>
                              <div
                                className={props.styles.hotel_autocomplete_name}
                                onClick={() => {
                                  props.onClickHotelName(recelement);
                                  props.isAutoCompleteExpand(false);
                                }}
                              >
                                <div
                                  className={
                                    props.styles.hotel_autocomplete_city
                                  }
                                >
                                  {recelement.search_text}
                                </div>

                                {/* <div
                                  className={
                                    props.styles.hotel_autocomplete_tag
                                  }
                                >
                                  {" "}
                                  {recelement.property_count} Properties
                                </div> */}
                              </div>
                              <div className={props.styles?.hotelnw_city}>
                                {recelement?.dest_type
                                  ? recelement?.dest_type?.text
                                  : " "}
                              </div>
                              {/* <div className={props.styles.hotelnw_city}>province state</div> */}
                            </div>
                          );
                        })}
                    </div>
                  </>
                )}

                {/* when user not Logged in  */}
                {props?.userProfile && props?.userProfile?.status == false && (
                  <>
                    <div className={props.styles.recent_container}>
                      {!commonFunction.isValueEmpty(
                        props.getrecentSearchList
                      ) &&
                        props.getrecentSearchList.length > 0 && (
                          <div className={props.styles.recent_label}>
                            Recent Search
                          </div>
                        )}

                      {!commonFunction.isValueEmpty(
                        props.getrecentSearchList
                      ) &&
                        props.getrecentSearchList.length > 0 &&
                        props.getrecentSearchList.map((recelement) => {
                          console.log("recelement", recelement);
                          return (
                            <div
                              className={
                                props.styles.hotel_autocomplete_element
                              }
                            >
                              {/* <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22"><path fill-rule="evenodd" d="m14.769 13.53-6.191 8.098c-.06.06-.151.121-.241.121a.277.277 0 0 1-.242-.121l-6.19-8.098a8.117 8.117 0 0 1 0-9.821C3.445 1.685 5.8.537 8.337.537c2.536 0 4.892 1.148 6.432 3.172a8.12 8.12 0 0 1 0 9.821zm-.483-9.458a7.48 7.48 0 0 0-5.949-2.93c-2.356 0-4.53 1.057-5.949 2.93a7.485 7.485 0 0 0 0 9.095l5.949 7.766 5.949-7.766a7.485 7.485 0 0 0 0-9.095zm-5.949 9.397c-2.658 0-4.832-2.175-4.832-4.834S5.679 3.8 8.337 3.8c2.657 0 4.831 2.176 4.831 4.835s-2.174 4.834-4.831 4.834zm0-9.064a4.241 4.241 0 0 0-4.228 4.23 4.242 4.242 0 0 0 4.228 4.23 4.242 4.242 0 0 0 4.228-4.23 4.241 4.241 0 0 0-4.228-4.23z"></path></svg> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M9.969 3.402V8.83c0 .124.05.243.138.33l3.863 3.836a.465.465 0 0 1-.33.795.466.466 0 0 1-.333-.137L9.445 9.818a1.393 1.393 0 0 1-.412-.988V3.402c0-.256.21-.464.468-.464.259 0 .468.208.468.464zm.747 14.331a8.652 8.652 0 0 1-4.864-.716.463.463 0 0 1-.2-.626.468.468 0 0 1 .63-.2 7.749 7.749 0 0 0 8.368-1.303 7.62 7.62 0 0 0 .525-10.816C12.314.941 7.439.708 4.287 3.55a7.622 7.622 0 0 0-.526 10.816v-1.009c0-.257.21-.465.469-.465.258 0 .468.208.468.465v2.092c0 .258-.21.466-.468.466H2.123a.466.466 0 1 1 0-.931h.953a8.582 8.582 0 0 1-2.15-4.567C.26 5.712 3.559 1.361 8.296.699c4.735-.66 9.112 2.616 9.779 7.319.665 4.701-2.628 9.048-7.359 9.715z"
                                />
                              </svg>
                              <div
                                className={props.styles.hotel_autocomplete_name}
                                onClick={() => {
                                  props.onClickHotelName(recelement);
                                  props.isAutoCompleteExpand(false);
                                }}
                              >
                                <div
                                  className={
                                    props.styles.hotel_autocomplete_city
                                  }
                                >
                                  {recelement.search_text}
                                </div>

                                {/* <div
                                  className={
                                    props.styles.hotel_autocomplete_tag
                                  }
                                >
                                  {" "}
                                  {recelement.property_count} Properties
                                </div> */}
                              </div>
                              <div className={props.styles?.hotelnw_city}>
                                {recelement?.dest_type
                                  ? recelement?.dest_type?.text
                                  : " "}
                              </div>
                              {/* <div className={props.styles.hotelnw_city}>province state</div> */}
                            </div>
                          );
                        })}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
